"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callUploadFile = void 0;
const abortable_fetch_1 = require("../../utils/abortable-fetch");
function callUploadFile(fileUrl, file) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return abortable_fetch_1.abortableFetch(`${fileUrl}`, {
        method: 'POST',
        body: formData,
    });
}
exports.callUploadFile = callUploadFile;
//# sourceMappingURL=files-api.js.map